import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadTimeCardsSuccess(timeCards) {
  return { type: types.LOAD_TIME_CARDS_SUCCESS, timeCards };
}

export function createTimeCardSuccess(timeCard) {
  return { type: types.CREATE_TIME_CARD_SUCCESS, timeCard };
}

export function updateTimeCardSuccess(timeCard) {
  return { type: types.UPDATE_TIME_CARD_SUCCESS, timeCard };
}

export function deleteTimeCardSuccess(timeCard) {
  return { type: types.DELETE_TIME_CARD_SUCCESS, timeCard };
}

export function loadTimeCards() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'time-cards/latest';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadTimeCardsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function loadUserTimeCards(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'user/' + parseInt(id, 10) + '/time-cards';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadTimeCardsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function loadUnsubmittedUserTimeCards(id) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'user/' + parseInt(id, 10) + '/time-cards/unsubmitted';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadTimeCardsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function loadUnapprovedTimeCards() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'time-cards/unapproved';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadTimeCardsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function saveTimeCard(timeCard) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let token = localStorage.getItem('accessToken');
    if (token)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    let url = baseApi + 'time-cards';
    if (timeCard.id) {
      url = baseApi + 'time-cards/' + timeCard.id;
      return axios
        .put(url, {
          ...timeCard,
        })
        .then((response) => {
          dispatch(updateTimeCardSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          payPeriodWeekId: timeCard.payPeriodWeekId,
          userId: timeCard.userId,
          isSubmitted: 0,
          submitDate: null,
          isApproved: 0,
          approvalDate: null,
        })
        .then((response) => {
          dispatch(createTimeCardSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deleteTimeCard(timeCard) {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'time-cards/' + timeCard.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deleteTimeCardSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/timeCardActions.js